import {
  faArrowPointer,
  faBadgeCheck,
  faCircle,
  faFileCode,
  faSackDollar,
  faUser,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { FontAwesomeIconProps } from '@fortawesome/react-fontawesome';

export const ClicksIcon = (props: Partial<FontAwesomeIconProps>) => (
  <FontAwesomeIcon
    icon={faArrowPointer}
    mask={faCircle}
    transform="shrink-6 right-1"
    {...props}
  />
);
export const ApplicationsIcon = (props: Partial<FontAwesomeIconProps>) => (
  <FontAwesomeIcon
    icon={faFileCode}
    mask={faCircle}
    transform="shrink-7"
    {...props}
  />
);
export const LeadsIcon = (props: Partial<FontAwesomeIconProps>) => (
  <FontAwesomeIcon
    icon={faUser}
    mask={faCircle}
    transform="shrink-7"
    {...props}
  />
);
export const FundedIcon = (props: Partial<FontAwesomeIconProps>) => (
  <FontAwesomeIcon
    icon={faSackDollar}
    mask={faCircle}
    transform="shrink-7"
    {...props}
  />
);
export const PreApprovedIcon = (props: Partial<FontAwesomeIconProps>) => (
  <FontAwesomeIcon
    icon={faBadgeCheck}
    mask={faCircle}
    transform="shrink-6"
    {...props}
  />
);
